enum ResizingAlgorithm {
  NEAREST = 'nearest',
  LINEAR = 'linear',
  CUBIC = 'cubic',
  LANCZOS2 = 'lanczos2',
  LANCZOS3 = 'lanczos3',
}

export default ResizingAlgorithm;
